// SimpleLineChart.tsx
import React from "react";
import { DailyAnalytics, SimpleLineChartProps } from "../types/revenue.types";

export const SimpleLineChart: React.FC<SimpleLineChartProps> = ({
  data,
  height = 200,
  color = "#3b82f6",
}) => {
  if (data.length === 0) {
    return (
      <div
        style={{
          height,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#6b7280",
          fontSize: "14px",
        }}
      >
        No data available
      </div>
    );
  }

  const maxValue = Math.max(
    ...data.map((d: DailyAnalytics) => Number(d.total_revenue) || 0),
  );
  const minValue = Math.min(
    ...data.map((d: DailyAnalytics) => Number(d.total_revenue) || 0),
  );
  const range = maxValue - minValue || 1;

  const formatDate = (dateString: string): string => {
    if (dateString.includes("T")) {
      return dateString.split("T")[0];
    }
    return dateString;
  };

  const formatDisplayDate = (dateString: string): string => {
    const date = formatDate(dateString);
    const [year, month, day] = date.split("-");
    return `${month}-${day}`;
  };

  return (
    <div style={{ height, position: "relative", padding: "20px 0" }}>
      <svg width="100%" height="100%" style={{ overflow: "visible" }}>
        {data.map((point: DailyAnalytics, index: number) => {
          const x = data.length > 1 ? (index / (data.length - 1)) * 100 : 50;
          const pointRevenue = Number(point.total_revenue) || 0;
          const y = 100 - ((pointRevenue - minValue) / range) * 80;
          const nextPoint = data[index + 1];

          return (
            <g key={index}>
              {nextPoint && (
                <line
                  x1={`${x}%`}
                  y1={`${y}%`}
                  x2={`${
                    data.length > 1
                      ? ((index + 1) / (data.length - 1)) * 100
                      : 50
                  }%`}
                  y2={`${
                    100 -
                    (((Number(nextPoint.total_revenue) || 0) - minValue) /
                      range) *
                      80
                  }%`}
                  stroke={color}
                  strokeWidth="2"
                />
              )}
              <circle
                cx={`${x}%`}
                cy={`${y}%`}
                r="4"
                fill={color}
                style={{ cursor: "pointer" }}
              >
                <title>{`${formatDate(
                  point.transaction_date,
                )}: $${pointRevenue.toFixed(2)}`}</title>
              </circle>
            </g>
          );
        })}
      </svg>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "10px",
          fontSize: "12px",
          color: "#6b7280",
        }}
      >
        <span>{formatDisplayDate(data[0]?.transaction_date)}</span>
        <span>
          {formatDisplayDate(
            data[Math.floor(data.length / 2)]?.transaction_date,
          )}
        </span>
        <span>
          {formatDisplayDate(data[data.length - 1]?.transaction_date)}
        </span>
      </div>
    </div>
  );
};
